import LoadScene from '@scenes/LoadScene';
import StartScene from '@scenes/StartScene';
import TutorialScene from '@scenes/TutorialScene';
import GameScene from '@scenes/GameScene';
import UiScene from '@scenes/UiScene';
import EndScene from '@scenes/EndScene';

export default [
  { key: 'LoadScene', scene: LoadScene, autoStart: true },
  { key: 'StartScene', scene: StartScene },
  { key: 'TutorialScene', scene: TutorialScene },
  { key: 'GameScene', scene: GameScene },
  { key: 'UiScene', scene: UiScene },
  { key: 'EndScene', scene: EndScene },
];
